// 価格表示: 金額を大きく、円(税込)を小さく 2026-08-31
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.price-item--regular, .price-item--sale').forEach(function(el) {
    var text = el.textContent.trim();
    var match = text.match(/^([\d,]+)\s*円/);
    if (match) {
      el.innerHTML = '<span class="ws-num">' + match[1] + '</span><span class="ws-unit">円（税込）</span>';
    }
  });
});
